import React, { useState } from "react";
import { Grid } from "semantic-ui-react";
import { phoneRegex } from "../../utils/regex";
const Input = ({
  getValue,
  getError,
  name,
  number,
  year,
  wide,
  phoneNumber,
  notReq,
}) => {
  const [value, setValue] = useState(null);
  const handleYearBlur = () => {
    if (value) {
      getValue(Number(value));
      getError(null);
    } else {
      getError("Enter year");
      getValue(null);
    }
  };
  const handleNumberBlur = () => {
    if (value) {
      getValue(Number(value));
      getError(null);
    } else {
      getError("Enter number");
      getValue(null);
    }
  };
  const handleStringBlur = () => {
    if (value) {
      getValue(value);
      getError(null);
    } else {
      getError("Fields with * are required");
      getValue(null);
    }
  };
  const handleNotReqBlur = () => {
    getValue(value);
    getError(null);
  };
  const handlePhoneBlur = () => {
    if (value && phoneRegex.test(value)) {
      getValue(value);
      getError(null);
    } else {
      getError("It should be cell number without any characters");
      getValue(null);
    }
  };
  return (
    <Grid.Column mobile={16} tablet={wide ? 16 : 8} computer={wide ? 16 : 8}>
      <div className="form-group ">
        <label htmlFor="tarvelteam">
          {name} {!notReq && <span className="required">*</span>}
        </label>
        <input
          id="tarvelteam"
          type="text"
          placeholder={`Enter ${name}`}
          autoComplete="off"
          onBlur={() =>
            year
              ? handleYearBlur()
              : number
              ? handleNumberBlur()
              : phoneNumber
              ? handlePhoneBlur()
              : notReq
              ? handleNotReqBlur()
              : handleStringBlur()
          }
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    </Grid.Column>
  );
};

export default Input;
